<template>
  <div class="questionnaire_detail_container">
    <detail :detail="detail" :mainBodyList="mainBodyList" @enterSubjects="enterSubjects" @setMainbodyId="setMainbodyId" v-if="!!detail && step==1"></detail>
    <subjects :params="params" :detailInfo="detail" :mainbodyId="mainbodyId" @submited="submited" @alreadySubmited="alreadySubmited" v-else-if="!!detail && step==2"></subjects>
  </div>
</template>
<script>
import { mapState } from "vuex";
import { loadStat } from "@/utils";
import qsApi from "@/api/apis/questionnaire.js";
import commApi from "@/api/apis/common.js";
import detail from "./components/Detail"; // 问卷详情
import Subjects from "./components/Subjects"; // 问卷题目详情
export default {
  name: "QuestionnaireDetail",
  data() {
    return {
      params: {
        contentType: 10,
        id: null,
        cId: null,
      },
      detail: null, // 详情
      mainbodyId: null, // 主体Id
      mainBodyList: null, // 多主体
      step: 1, // 当前处于第几步
      shareUrl: "",
    };
  },
  computed: {
    ...mapState("app", ["userInfo", "nodeCode"]),
  },
  components: {
    detail,
    Subjects,
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (from.path == "/index_share") {
        vm.shareUrl = location.href.replace("/questionnaire_detail?", "/index_share?");
      } else {
        vm.shareUrl = location.href;
      }
    });
  },
  methods: {
    /* 微信二次分享 */
    wechatShare() {
      var _this = this;

      commApi.getWeiXinTicket({
        nodeCode: _this.nodeCode,
        url: _this.shareUrl
      }).then((res) => {
        _this.$WeiXin.shareWeiXin(res, _this.detail.title + " - 法治号客户端", _this.detail.introduction, _this.shareUrl, _this.detail.focusPicUrl);
      }).catch((err) => {

      })
    },
    /* 获取问卷详情 */
    getQuestionnaireDetail() {
      var _this = this;
      var params = {
        memberId: _this.userInfo.id,
        questionnaireId: _this.params.id,
      };
      qsApi
        .getQuestionnaireDetail(params)
        .then((res) => {
          if (res.suc == 1) {
            _this.detail = res.data;
            if (_this.detail.isMultiagent) {
              _this.getMainbodyList(); // 获取多主体
            }
            _this.wechatShare(); // 微信二次分享
          }
        })
        .catch((err) => {
          _this.$toast({
            message: "接口调用出错",
            position: "center",
          });
        });
    },
    /* 只获取问卷详情 */
    getQuestionnaireDetailOnly() {
      var _this = this;
      var params = {
        memberId: _this.userInfo.id,
        questionnaireId: _this.params.id,
      };
      qsApi
        .getQuestionnaireDetail(params)
        .then((res) => {
          if (res.suc == 1) {
            _this.detail = res.data;
          }
        })
        .catch((err) => {
          _this.$toast({
            message: "接口调用出错",
            position: "center",
          });
        });
    },
    /* 获取多主体 */
    getMainbodyList() {
      var _this = this;
      qsApi
        .getMainbodyList({ questionnaireId: _this.params.id })
        .then((res) => {
          if (res.suc == 1) {
            let list = res.data.list;
            var array = [];
            list.forEach(function (item, i) {
              var childArray = [];
              item.classify.forEach(function (subItem, j) {
                childArray.push({
                  text: subItem.childMainbodyName,
                  id: subItem.childId,
                  type: subItem.childType,
                });
              });
              // 为了防止报错，无二级时默认设置一个空字符串
              if (childArray.length == 0) {
                childArray.push({ text: "" });
              }
              array.push({
                text: item.mainbodyName,
                id: item.id,
                type: item.type,
                children: childArray,
              });
            });
            _this.mainBodyList = array;
          }
        })
        .catch((err) => {
          _this.$toast({
            message: "接口调用出错",
            position: "center",
          });
        });
    },
    /* 设置 setMainbodyId */
    setMainbodyId(data) {
      this.mainbodyId = data;
    },
    /* 进入题目列表  */
    enterSubjects(data) {
      if (data) {
        this.step = 2;
      }
    },
    /* 成功提交答题问卷后改变状态 */
    submited(data) {
      this.getQuestionnaireDetail();
      this.step = 1;
    },
    /* 已经提交过 */
    alreadySubmited() {
      this.getQuestionnaireDetailOnly();
      this.step = 1;
    },
  },
  created() {
    document.title = "问卷调查";
    let query = this.$route.query;
    if (!!this.userInfo) {
      if (Object.prototype.hasOwnProperty.call(query, "id")) {
        this.params.contentType = Number(query.contentType) || 10;
        this.params.id = Number(query.id);
        this.params.type = Number(query.type) || 2;
        this.getQuestionnaireDetail(); // 获取问卷详情
        loadStat(); // 友盟统计
      } else if (Object.prototype.hasOwnProperty.call(query, "contentId")) {
        this.params.contentType = Number(query.contentType) || 10;
        this.params.id = Number(query.contentId);
        this.params.type = Number(query.type) || 2;
        this.getQuestionnaireDetail(); // 获取问卷详情
        loadStat(); // 友盟统计
      }
    } else {
      this.$router.push("/login");
    }
  },
};
</script>
<style scoped lang="scss">
.questionnaire_detail_container {
  width: 100%;
  height: 100%;
  padding: 0px;
  background: #f6f6f6;
  overflow: hidden;
}
</style>